"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const Survicate_1 = require("configs/Survicate");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const legacyRedirect_1 = require("modules/app/services/datahub/legacyRedirect");
const DashboardService_1 = __importDefault(require("modules/dashboard/DashboardService"));
const STORAGE_BASE_KEY = 'redirectAlertClosed';
const useLegacyClubRedirect = (productId) => {
    const storageKey = `${STORAGE_BASE_KEY}:${productId}`;
    const [shouldRenderAlert, setShouldRenderAlert] = (0, react_1.useState)(() => {
        const storageData = sessionStorage.getItem(storageKey);
        return storageData !== 'true';
    });
    const [hotmartClubData, setHotmartClubData] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const fetchHotmartClubData = async () => {
            const data = await DashboardService_1.default.hasNewClub(productId);
            setHotmartClubData(data);
        };
        fetchHotmartClubData();
    }, [productId]);
    const hasNewClub = Boolean(hotmartClubData || !(0, isEmpty_1.default)(hotmartClubData));
    const handleCloseAlert = (mustChangeState) => {
        if (mustChangeState) {
            setShouldRenderAlert(false);
        }
        sessionStorage.setItem(storageKey, String(true));
        legacyRedirect_1.DatahubLegacyRedirectService.closeAlertEvent();
        (0, Survicate_1.showSurvey)(Survicate_1.SURVEY_ID_LIST.LEGACY_REDIRECT_ALERT);
    };
    return {
        shouldRenderAlert,
        hasNewClub,
        handleCloseAlert
    };
};
exports.default = useLegacyClubRedirect;
